export default __webpack_public_path__ + "static/media/iconSuccesCompany.45a43915.svg";